import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../styles/pages/promotions_page.css";
import Header from "../components/Header.jsx";
import Button from "../components/Button.jsx";
import Loader from "../components/Loader";
import Item from "../components/Item.jsx";
import Modal from "../components/Modal.jsx";
import PromotionForm from "../components/PromotionForm.jsx";

import { fetchPromotions, deletePromotion } from "../services/promotionsService";

import { IMAGE_BASE_URL } from "../services/imageConfig";

const processImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  const normalized = url.startsWith("/") ? url : `/${url}`;
  return `${IMAGE_BASE_URL}${normalized}`;
};

const PromotionsPage = () => {
  const [promotionsItems, setPromotionsItems] = useState([]);
  const [showPromotionForm, setShowPromotionForm] = useState(false);
  const [currentPromotionData, setCurrentPromotionData] = useState(null);
  const [formMode, setFormMode] = useState("create");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [promotionToDelete, setPromotionToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const loadPromotions = async () => {
    setIsLoading(true);
    try {
      const data = await fetchPromotions().catch((err) => {
        if (err.response?.status === 404) return [];
        throw err;
      });
      setPromotionsItems(
        data.map((promotion) => ({
          id: promotion.id,
          title: promotion.title,
          hasEdit: true,
          fullData: {
            id: promotion.id,
            titleImage: processImageUrl(promotion.titleImage),
            date: promotion.date,
            dateOfExpiry: promotion.dateOfExpiry,
            title: promotion.title,
            description: promotion.description,
            promotionStatus: promotion.promotionStatus,
            promotionDetails: promotion.promotionDetails,
            imageFirst: processImageUrl(promotion.imageFirst),
            imageSecond: processImageUrl(promotion.imageSecond),
            promotionWinners: promotion.promotionWinners,
          },
        }))
      );
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error("Время сессии истекло, пожалуйста войдите заново", {
          position: "bottom-left",
          autoClose: 3000,
        });
      } else {
        toast.error("Ошибка загрузки акций", {
          position: "bottom-left",
          autoClose: 3000,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadPromotions();
  }, []);

  const handleEditPromotion = (promotion) => {
    setCurrentPromotionData(promotion.fullData);
    setFormMode("edit");
    setShowPromotionForm(true);
  };

  const handleCreatePromotion = () => {
    setCurrentPromotionData(null);
    setFormMode("create");
    setShowPromotionForm(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await deletePromotion(promotionToDelete.id);
      setPromotionsItems((prev) =>
        prev.filter((item) => item.id !== promotionToDelete.id)
      );
      toast.success("Акция успешно удалена", {
        position: "bottom-left",
        autoClose: 3000,
      });
      setShowDeleteModal(false);
      setPromotionToDelete(null);
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error("Время сессии истекло, пожалуйста войдите заново", {
          position: "bottom-left",
          autoClose: 3000,
        });
      } else {
        toast.error("Ошибка при удалении акции", {
          position: "bottom-left",
          autoClose: 3000,
        });
      }
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setPromotionToDelete(null);
  };

  return (
    <div className="promotions-page">
      <Header />
      <ToastContainer />

      {isLoading ? (
        <div className="loader-wrapper">
          <Loader />
          <p className="loading-text">Загрузка акций...</p>
        </div>
      ) : (
        <div className="promotions-page_content">
          <div className="promotions_section">
            <h3 className="section-title">Список акций</h3>
            <div className="items-container">
              {promotionsItems.length > 0 ? (
                promotionsItems.map((item, index) => (
                  <div key={item.id} className="numbered-item">
                    <span className="item-number">{index + 1}</span>
                    <Item
                      imageSrc={item.fullData.titleImage}
                      title={item.title}
                      onEdit={() => handleEditPromotion(item)}
                      onDelete={() => {
                        setPromotionToDelete(item);
                        setShowDeleteModal(true);
                      }}
                    />
                  </div>
                ))
              ) : (
                <p className="empty-list-label">Список пуст</p>
              )}
              <Button text={"+ Добавить"} onClick={handleCreatePromotion} />
            </div>
          </div>
        </div>
      )}

      {showPromotionForm && (
        <PromotionForm
          onClose={() => setShowPromotionForm(false)}
          initialData={currentPromotionData}
          mode={formMode}
          onSuccess={loadPromotions}
        />
      )}

      {showDeleteModal && (
        <Modal
          isOpen={showDeleteModal}
          message="Вы действительно хотите удалить акцию?"
          itemTitle={promotionToDelete?.title}
          onCancel={handleCancelDelete}
          onConfirm={handleConfirmDelete}
        />
      )}
    </div>
  );
};

export default PromotionsPage;
